<template>
  <b-col md="4" sm="4" class="m-t-20">
     <section class="single-rating">
        <h4 class="designername">{{ singleRating.uploader }}</h4>
        <star-rating inactive-color="#e1bad9" active-color="#cc1166"  class="star-rating m-b-20" :star-size="20" :read-only="true"  :rating="singleRating.averageRating" :increment="0.01" :fixed-points="1"></star-rating>
        <p class="rating-info">
          Ratings from {{singleRating.ratings.length}} responses 
        </p>
     </section>
  </b-col>
</template>

<script>
import StarRating from 'vue-star-rating';

  export default {
    components: {StarRating},
    props: {
      singleRating: {
         type: Object,
         default: () => ({})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .designername {
    text-transform: capitalize;
  }
  .single-rating{
    border: 1px solid rgb(209, 209, 209);
    padding: 20px;
    border-radius: 5px;
  }
  .rating-info{
    margin-bottom: 0;
    font-size: 13px;
    color: #7a7a7a;
  }
</style>